const { dY } = require("@fullcalendar/core/internal-common");

$(document).ready(function () {
  addToSummary();
  addToInvoice();
  canvasSize();
  checkAll();
  changeTvGroup();
  colspans();
  collapseIconChange();
  copyToClipboard();
  connectable();
  current_day_background();
  drag_n_drop_task();
  drag_n_drop_kanban();
  draw_on_resize();
  fakeDateField();
  flatpicker();
  get_all_tasks_positions();
  handleProducts();
  inlineUpdate();
  initilizeUppy();
  invoiceAll();
  orderSelected();
  removeFromSummary();
  removeFromInvoice();
  renewSelected();
  selectAll();
  selectpicker();
  sortables();
  toggleFields();
  toggles();
  updateFlowNameSelect();
  updateLicenseSelect();
  updateAgentsSelect();
  updateSelect();
  validate_project();
  clock();
  reloadTvPage();
  allow_tab_text_area();
  rightClick();
});

$(document).ajaxComplete(function () {
  collapseIconChange();
  initilizeUppy();
  selectpicker();
  toggles();
  toggleFields();
  updateSelect();
  inlineUpdate();
  updateLicenseSelect();
  flatpicker();
  allow_tab_text_area();
  activityNoteSubmit();
  updateAgentsSelect();
});

window.activityNoteSubmit = function () {
  $('#activity-note-form').on('submit', function (e) {
    e.preventDefault();

    var form = $(this);
    var formData = new FormData(this);

    $.ajax({
      url: form.attr('action'),
      type: form.attr('method') || 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'script',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    });
  });
}

window.rightClick = function () {
  $(".tl_item").on('mousedown', function (ev) {
    if (ev.which == 3) {
      document.getElementById("rmenu").className = "show-menu";
      document.getElementById("rmenu").style.top = ev.clientY - 170 + 'px';
      document.getElementById("rmenu").style.left = ev.clientX - 15 + 'px';
      var activity_id = $(this).data('activity')
      var url = "/activity_groups/timeline?start_date=" + $(this).data('var');
      $.ajax({
        type: 'GET',
        url: url,
        data: { activity_id: activity_id },
        dataType: 'script'
      });
    }
  });
  $(".timeline").on('mousedown', function (ev) {
    if (ev.which == 1) {
      document.getElementById("rmenu").className = "hide-menu";
    }
  });
}

window.reloadMenu = function (activity_id) {
  temp = $("#rmenu");
  url = "/activity_groups/timeline_menu";
  $.ajax({
    type: 'GET',
    url: url,
    success: function (data) {
      $("#rmenu").html(data['new_html']);
    },
    data: { activity_id: activity_id },
    dataType: 'json'
  });
}

window.allow_tab_text_area = function () {
  $('.text').on('keydown', function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9) {
      e.preventDefault();
      var start = this.selectionStart;
      var end = this.selectionEnd;
      this.value = this.value.substring(0, start) + "\t" + this.value.substring(end);
      this.selectionStart =
        this.selectionEnd = start + 1;
    }
  });
}

window.current_day_background = function () {
  if ($('.timeline').length > 0) {
    var today = new Date();
    $('.timeline_col').each(function (index, col) {
      if (new Date($(col).data('day')).toDateString() == today.toDateString()) {
        $(col).children().first().css("border", "1px solid #ff9999");
        $(col).children().first().css("margin-left", "-1px");
        $(col).children().last().css("border-right", "1px dotted #ff9999");
        $(col).children().last().css("border-left", "1px dotted #ff9999");
        $(col).children().last().css("margin-left", "-1px");
      }
    });
  }
}

window.flatpicker = function () {
  const Italian = require("flatpickr/dist/l10n/it.js").default.it;
  flatpickr("[data-behavior='flatpickr']", {
    dateFormat: "Y-m-d",
    "locale": Italian,
  });
  flatpickr("[data-behavior='flatpickr_complete']", {
    dateFormat: "Y-m-d",
    "locale": Italian,
  });
}

window.reloadActivity = function (activity_id) {
  temp = $("#att_" + activity_id).children();
  url = temp.data("url") + "/activities/" + activity_id + "/reload_kanban_activity";
  $.ajax({
    type: 'GET',
    url: url,
    success: function (data) {
      $("#att_" + activity_id).html(data['new_html'])
      drag_n_drop_kanban();
    },
    data: { activity_id: activity_id },
    dataType: 'json'
  });
}

window.changeTvGroup = function () {
  $('.next_arrow').on("click", function () {
    window.location = "/tv?group_id=" + $('.tv').data("next_id")
  })
  $('.prev_arrow').on("click", function () {
    window.location = "/tv?group_id=" + $('.tv').data("prev_id")
  })
}

window.reloadTvPage = function () {
  if ($('.tv').length > 0) {
    setTimeout(function () {
      window.location = "/tv?group_id=" + $('.tv').data("next_id")
    }, 600000);
  }
}

window.clock = function () {
  if ($('.tv').length > 0) {
    const today = new Date();

    // get time components
    const hours = today.getHours();
    const minutes = today.getMinutes();
    const seconds = today.getSeconds();

    //add '0' to hour, minute & second when they are less 10
    const hour = hours < 10 ? "0" + hours : hours;
    const minute = minutes < 10 ? "0" + minutes : minutes;
    const second = seconds < 10 ? "0" + seconds : seconds;

    //make clock a 12-hour time clock
    // const hourTime = hour > 12 ? hour - 12 : hour;

    // if (hour === 0) {
    //   hour = 12;
    // }
    //assigning 'am' or 'pm' to indicate time of the day
    // const ampm = hour < 12 ? "AM" : "PM";

    // get date components
    const month = today.getMonth();
    const year = today.getFullYear();
    const day = today.getDate();

    //declaring a list of all months in  a year
    const monthList = [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ];

    //get current date and time
    const date = day + " " + monthList[month] + " " + year;
    // const time = hourTime + ":" + minute + ":" + second + ampm;
    // const time = hour + ":" + minute + ":" + second;
    const time = hour + ":" + minute;

    //combine current date and time
    const dateTime = date + " - " + time;

    //print current date and time to the DOM
    document.getElementById("date_time").innerHTML = dateTime;
    setTimeout(clock, 1000);
  }
}



window.canvasSize = function () {
  if ($('#canvascontainer').length > 0) {
    var canvas = document.getElementById("canvascontainer");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
}

window.get_all_tasks_positions = function (clear) {
  if ($('#workspace').length > 0) {
    //prendo origine canvas per usarla come offset per le posizioni
    px = $('#canvascontainer').offset().left
    py = $('#canvascontainer').offset().top
    $('.row').children().each(function (col_index, col) {
      $(col).children().each(function (task_index, task) {

        task_id = $(this).data("taskid");
        connected_tasks = $(this).data("connectedtasks");
        width = $(this).width();
        start_pos_x = $(this).offset().left - px + 2;
        start_pos_y = $(this).offset().top - py + 50;
        start_pos_x = start_pos_x + width;

        $(connected_tasks).each(function (connected_task_index, connected_tasks) {
          $('.row').children().each(function (col_index, col) {
            $(col).children().each(function (task_index, task) {

              task_id = $(this).data("taskid");
              if (task_id == connected_tasks) {
                dest_pos_x = $(this).offset().left - px + 2;
                dest_pos_y = $(this).offset().top - py + 50;

                draw_line(start_pos_x, start_pos_y, dest_pos_x, dest_pos_y, clear);
                clear = false;

              }
            })
          })
        })
      })
    })
  }
}

window.draw_on_resize = function () {
  $(window).resize(function () {
    clear = true;
    get_all_tasks_positions(clear);
  });
}

window.draw_line = function (x1, y1, x2, y2, clear) {

  // preparazione dati x disegnarela freccia
  var c = document.getElementById("canvascontainer");
  var ctx = c.getContext("2d");
  ctx.fillStyle = "black";
  headlen = 10;
  dx = x2 - x1;
  dy = y2 - y1;
  angle = Math.atan2(dy, dx);

  // controllo se devo cancellare tutte le frecce presenti(solo on resize)
  if (clear == true) {
    ctx.clearRect(0, 0, c.width, c.height);
    shapes = [];
  }

  // disegno la freccia
  ctx.beginPath();

  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);

  ctx.stroke();

  ctx.beginPath();

  ctx.moveTo(x2, y2);
  ctx.lineTo(x2 - headlen * Math.cos(angle - Math.PI / 6), y2 - headlen * Math.sin(angle - Math.PI / 6));

  ctx.lineTo(x2 - headlen * Math.cos(angle + Math.PI / 6), y2 - headlen * Math.sin(angle + Math.PI / 6));


  ctx.fill();
  ctx.stroke();

}

window.connectable = function () {
  var i = 0;
  var ids = [];
  var col1 = null;
  var col2 = null;
  $('.task').on("click", function () {
    $(this).addClass("connectable")
    var url = $(this).data("url") + "/activity_sequences";
    ids[i] = $(this).data("taskid");
    if (ids.length == 2) {
      col2 = $(this).data("col");
      if (col1 < col2) {
        $.ajax({
          type: 'POST',
          url: url,
          data: { tasks_ids: ids },
          dataType: 'script'
        });
      }
      else {
        location.reload();
      }
      i = 0;
    }
    else {
      col1 = $(this).data("col");
      i = i + 1;
    }
    return false;
  });
}

window.drag_n_drop_task = function () {
  var activity_id = null;
  var url = $('.draggable_task').data("url") + "/save_positions";
  $('.draggable_task').draggable({
    revert: true,
    scroll: false,
    start: function (e, ui) {
      activity_id = $(this).data('taskid');
    },
    stop: function (e, ui) {
      $('.drop_column').removeClass('drop_zone');
    },
    drag: function (event, ui) {
      $('.drop_column').addClass('drop_zone');
    },
    zIndex: 100
  });
  $('.drop_column').droppable({
    greedy: true,
    drop: function (event, ui) {
      $(this).append($(ui.draggable));
      var col = $(this).data('col');
      $.ajax({
        type: 'GET',
        url: url,
        data: { activity_id: activity_id, col: col },
        dataType: 'script'
      });
    }
  });
}

window.validate_project = function () {
  if ($('#workspace').length > 0) {
    $('.draggable_task').each(function (index, task) {
      if ($(this).data("error") == true) {
        $(this).addClass("error");
      }
    });
  };
}

window.drag_n_drop_kanban = function () {
  if ($('.tv').length == 0) {
    var activity_id = null;
    var url = $('.activity').data("url") + "/update_status";
    $('.activity').each(function (draggable_activity_index, draggable_activity) {
      if ($(this).data("workable") == true) {
        $(this).css("opacity", "unset");
        $(this).draggable({
          revert: function (event, ui) {
            $(this).data("uiDraggable").originalPosition
            $(this).css({ "position": "relative" });
            return !event;
          },
          scroll: false,
          helper: "clone",
          start: function (e, ui) {
            $(ui.helper).addClass("ui-draggable-helper");
            $(this).css("opacity", 0.5);
            activity_id = $(this).data('taskid');
          },
          stop: function (e, ui) {
            $(this).css("opacity", "unset");
          },
          zIndex: 100,
          drag: function (event, ui) {
          }
        });
      }
    })
    $('.column').droppable({
      accept: ".activity",
      greedy: true,
      hoverClass: "hover",
      zIndex: 0,
      over: function (event, ui) {
        if ($(this).data('status') === 'new_opportunities') {
          $(this).removeClass('hover');
        }
      },
      drop: function (event, ui) {
        var status = $(this).data('status');
        if (status === 'new_opportunities') {
          return; // non faccio nulla, il draggable torna indietro per via di revert
        }
        if ($('#opportunity_kanban').length > 0) {
          var customer_id = $(ui.draggable).data("customer-id");
          var opportunity_id = $(ui.draggable).data("opportunity-id");
          var previous_task_id = $(ui.draggable).data("task-id")
          $.get("/customers/" + customer_id + "/opportunities/" + opportunity_id + "/tasks/new", { kind: status, previous_task_id: previous_task_id }, function (html) {
            $("#modal_container").html(html);
            $("#modal_container .modal").modal("show");
          });
        } else {
          $.ajax({
            type: 'GET',
            url: url,
            success: function (data) {
              $("#att_" + activity_id).remove();
              $("#" + data['status']).prepend("<div class='random_att' id='att_" + activity_id + "'>" + data['new_html'] + "</div>");
              if ($('.dashboard').length > 0) {
                $("#activity_row_" + activity_id).remove();
                $('.dashboard_activities_table').prepend(data['new_activity']);
              }
              drag_n_drop_kanban();
            },
            data: { activity_id: activity_id, status: status },
            dataType: 'json'
          });
        }
      }
    });
  }
}

window.fakeDateField = function () {
  $(".fake_date_field").each(function (i, el) {
    if ($(el).val()) {
      this.type = 'date';
    }
    $(el).on('focus', function () {
      this.type = 'date';
      this.click();
    });
    $(el).on('focusout', function () {
      if (this.value == '') {
        this.type = 'text';
      }
    });
  });
}

window.renewSelected = function () {
  $("#renew_selected").click(function () {
    var r = confirm("Confermi?");
    if (r == true) {
      var url = "/customers/renew_selected_licenses";
      var license_ids = $('.check_license:checkbox:checked').map(function () {
        return this.value;
      }).get();
      $.ajax({
        type: 'PATCH',
        url: url,
        data: { license_ids: license_ids },
        dataType: 'script'
      });
      return false;
    }
  });
}

window.orderSelected = function () {
  $("#order_selected").click(function () {
    var r = confirm("Confermi?");
    if (r == true) {
      var url = "/customers/order_selected_licenses";
      var license_ids = $('.check_license:checkbox:checked').map(function () {
        return this.value;
      }).get();
      $.ajax({
        type: 'PATCH',
        url: url,
        data: { license_ids: license_ids },
        dataType: 'script'
      });
      return false;
    }
  });
}

window.invoiceAll = function () {
  $("#invoice_all").one('click', function (event) {
    event.preventDefault();
    $(this).prop('disabled', true);
    var url = "/invoices/invoice_all?";
    var kind = $(this).data("kind");
    var item_ids = $('.check_invoice:checkbox:checked').map(function () {
      return this.value;
    }).get();
    $.ajax({
      type: 'GET',
      url: url,
      data: { item_ids: item_ids },
      dataType: 'script'
    });
    return false;
  });
}

window.copyToClipboard = function () {
  $('.clipboard-btn').each(function () {
    var element = $(this)
    var text = element.data("text");
    element.click(function (el) {
      el.preventDefault();
      navigator.clipboard.writeText(text).then(function () {
        element.removeClass('btn-secondary').addClass('btn-success');
      }, function (err) {
        element.removeClass('btn-secondary').addClass('btn-danger');
      });
    });
  });
}

window.checkAll = function () {
  $("#check_all").click(function () {
    $("input[type=checkbox]").prop('checked', $(this).prop('checked'));
  });
}

window.initilizeUppy = function () {
  $(".upload_file").on("dragover", function (e) {
    $(this).click();
  });
  if ($("#drag-drop-area").length > 0) {
    const Uppy = require('@uppy/core')
    const XHRUpload = require('@uppy/xhr-upload')
    const Dashboard = require('@uppy/dashboard')
    require('@uppy/core/dist/style.css')
    require('@uppy/dashboard/dist/style.css')
    const Italian = require('@uppy/locales/lib/it_IT')
    if ($("#drag-drop-area[data-uppy-max-files]").length) {
      uppy_max_files = $('#drag-drop-area').data("uppy-max-files");
    } else {
      uppy_max_files = 1
    }
    const uppy = Uppy({
      autoProceed: false,
      locale: Italian,
      restrictions: {
        maxNumberOfFiles: uppy_max_files,
        minNumberOfFiles: 1
      }
    })
    uppy.use(Dashboard, {
      target: '#drag-drop-area',
      inline: true,
      height: 300
    });
    uppy.use(XHRUpload, {
      endpoint: $('#drag-drop-area').data('url'),
      timeout: 300 * 1000,
      bundle: true,

      getResponseData(responseText, response) {
        return {
          url: responseText
        }
      }
    })
    uppy.on('complete', (result) => { location.href = result.successful[0].response.body.url })
    $('.uppy-Dashboard-poweredBy').hide();
  }
}


window.handleProducts = function () {
  $('.remove_row').each(function () {
    $(this).click(function (e) {
      e.preventDefault();
      $(this).closest('tr').remove();
      new_count = $(this).data('count');
      selected = $(this).data('id');
      product_ids = [$("#array_" + new_count).val()];
      product_ids = product_ids.toString().replace(',' + selected, '');
      $("#array_" + new_count).val(product_ids);
    });
  });
}

window.inlineUpdate = function () {
  $(".inline_select").each(function (i, el) {
    $(el).change(function () {
      id = $(el).data('id');
      param = $(el).data('param');
      url = "/work_hours/" + id + "/inline_update?summary=" + $(el).data('summary');
      $.ajax({
        type: 'PATCH',
        url: url,
        beforeSend: function () {
          $(el).prop("disabled", true);
        },
        error: function (data) {
          $(el).prop("disabled", false);
          $("#p_" + id).removeClass('alert-success').addClass('alert-danger').fadeIn('slow');
          $("#p_" + id).html('<span>Errore. Riprovare!</span>');
          setTimeout(function () { $("#p_" + id).fadeOut('slow'); }, 3000);
        },
        success: function (data) {
          $("#summary_table").replaceWith(data);
          $(el).prop("disabled", false);
          if (data['code'] == '500') {
            $("#p_" + id).removeClass('alert-success').addClass('alert-danger').html('<span>Errore. Riprovare!</span>');
          } else if (data['code'] == '400') {
            $("#p_" + id).removeClass('alert-success').addClass('alert-danger').html('<span>Errore, non è possibile aggiornare il dato.</span>');
          }
          $("#p_" + id).fadeIn('slow');
          setTimeout(function () { $("#p_" + id).fadeOut('slow'); }, 3000);
        },
        data: { attribute: param, value: $(el).val() },
        dataType: 'json'
      });
    });
  });
}

window.removeFromInvoice = function () {
  $('.remove_from_invoice').click(function () {
    email_body = $.trim($('#invoice_description').val());
    kind = $(this).data('kind');
    item_id = $(this).data('item');
    url = $("form:first").attr('action');
    $.ajax({
      type: 'PATCH',
      url: url + '/remove_from_invoice',
      data: { kind: kind, item_id: item_id, description: description }
    });
  });
}

window.removeFromSummary = function () {
  $('.remove_from_summary').click(function () {
    email_body = $.trim($('#summary_email_body').val());
    kind = $(this).data('kind');
    item_id = $(this).data('item');
    url = $("form:first").attr('action');
    $.ajax({
      type: 'PATCH',
      url: url + '/remove_from_summary',
      data: { kind: kind, item_id: item_id, email_body: email_body }
    });
  });
}

window.addToInvoice = function () {
  $('#add_to_invoice').click(function () {
    work_hours = new Array();
    events = new Array();
    activity_notes = new Array();
    $('#work_hours').find('input[type="checkbox"]:checked').each(function () {
      kind = $(this).attr('name');
      id = $(this).val();
      if (kind == 'work_hour') {
        work_hours.push(id);
      } else if (kind == 'event') {
        events.push(id);
      } else if (kind == 'activity_note') {
        activity_notes.push(id);
      }
    });
    if (work_hours.length > 0 || events.length > 0 || activity_notes.length > 0) {
      url = $("form:first").attr('action');
      description = $.trim($('#invoice_description').val());
      $.ajax({
        type: 'PATCH',
        url: url + '/add_to_invoice',
        data: { work_hours: work_hours, events: events, activity_notes: activity_notes, description: description }
      });
    }
  });
}

window.addToSummary = function () {
  $('#add_to_summary').click(function () {
    work_hours = new Array();
    events = new Array();
    activity_notes = new Array();
    $('#work_hours').find('input[type="checkbox"]:checked').each(function () {
      kind = $(this).attr('name');
      id = $(this).val();
      if (kind == 'work_hour') {
        work_hours.push(id);
      } else if (kind == 'event') {
        events.push(id);
      } else if (kind == 'activity_note') {
        activity_notes.push(id);
      }
    });
    if (work_hours.length > 0 || events.length > 0 || activity_notes.length > 0) {
      url = $("form:first").attr('action');
      email_body = $.trim($('#summary_email_body').val());
      $.ajax({
        type: 'PATCH',
        url: url + '/add_to_summary',
        data: { work_hours: work_hours, events: events, activity_notes: activity_notes, email_body: email_body }
      });
    }
  });
}

window.selectAll = function () {
  $('#select_all').change(function () {
    if (this.checked) {
      $('#work_hours').find('input[type="checkbox"]').each(function () {
        this.checked = true;
      });
    } else {
      $('#work_hours').find('input[type="checkbox"]').each(function () {
        this.checked = false;
      });
    }
  });
}

window.collapseIconChange = function () {
  $("[data-toggle='collapse']").each(function (i, el) {
    $(el).on("click", function () {
      target = $($(el).data('target'));
      if ($('.tv').length == 0) {
        children = $(el).find("svg");
        if ($(el).data('parent') && !target.hasClass('show')) {
          $('.fa-caret-square-down').each(function (j, obj) {
            $(obj).removeClass('fa-caret-square-up');
            $(obj).addClass('fa-caret-square-down');
          });
        }
        if (children.hasClass('fa-caret-square-up')) {
          children.removeClass('fa-caret-square-up').addClass('fa-caret-square-down');
        } else {
          children.removeClass('fa-caret-square-down').addClass('fa-caret-square-up');
        }
      }
    });
  });
}




window.colspans = function () {
  $('td.colspan').each(function (i, el) {
    var count = 0
    $(el).closest('table').find('tr th').each(function (i, el) {
      if ($(el).attr('colspan')) {
        count += parseInt($(el).attr('colspan'));
      } else {
        count += 1;
      }
    });
    $(el).attr('colspan', count);
  });
}

window.selectpicker = function () {
  $('.selectpicker').selectpicker();
}

window.sortables = function () {
  $('ul.sortable').sortable({
    axis: 'y',
    update: function (event, ui) {
      ui.item.effect('highlight', {}, 1000),
        $.ajax({
          data: {
            position: ui.item.index()
          },
          type: 'PATCH',
          url: ui.item.data('action'),
        });
    }
  });
}

window.toggles = function () {
  $("[data-behaviour='toggle']").each(function (i, el) {
    var div = $(el);
    div.children('a').on('click', function () {
      var url = $(this).data('url');
      $.ajax({
        type: 'PATCH',
        url: url,
        beforeSend: function () {
          $(this).removeClass('btn-success').removeClass('btn-danger').addClass('btn-warning');
        },
        success: function (data) {
          div.replaceWith(data);
        },
        dataType: 'html'
      });
    });
  });
}

window.toggleFields = function () {
  $("[data-behaviour='toggle_fields']").each(function (i, el) {
    toggleFieldsVisibility(el);
    $(el).change(function () {
      toggleFieldsVisibility(el);
    });
  });
}

window.toggleFieldsVisibility = function () {
  $("[data-dependency]").each(function (i, el) {
    target = $(this).data("dependency");
    values = $(this).data('dependencyvalue').toString();
    if (values.indexOf(',') > -1) {
      values = values.split(',');
    } else {
      values = [values];
    }
    condition = $(this).data('dependencycondition');
    if (target.startsWith('.')) {
      target_value = $(el).find('select' + target).val();
    } else {
      target_value = $("#" + target).val();
    }
    switch (condition) {
      case 'Not-equals':
        if ($.inArray(target_value, values) == -1 && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
        break;
      case 'Equals':
        if ($.inArray(target_value, values) != -1 && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
        break;
      case 'Contains':
        if (String(target_value).indexOf(String(values)) >= 0 && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
      case 'Does not contain':
        if (String(target_value).indexOf(String(values)) == -1 && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
      case 'Starts with':
        if (String(target_value).match("^" + String(values)) && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
      case 'Does not start with':
        if (String(target_value).match("^" + String(values)) == null && target_value != '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
      case 'Not-present':
        if (String(target_value) == '') {
          $(el).show();
          $(el).find('*').filter(':input:first').prop("disabled", false);
        } else {
          $(el).hide();
          $(el).find('*').filter(':input:first').prop("disabled", true).val('');
        }
    }
  });
}

window.updateFlowNameSelect = function () {
  $("[data-update='flow_name_select']").change(function (el) {
    param = this.value;
    datatarget = $(this).data('kind');
    target = $("#" + datatarget);
    url = "/switch_data/get_flows_enum?enum_value=" + param;
    $.getJSON(url, function (json) {
      target.empty();
      target.append($('<option>').text("Seleziona..."));
      $.each(json, function (i, obj) {
        target.append($('<option>').text(obj.text).attr('value', obj.value));
      });
    });
  });
}

window.updateLicenseSelect = function () {
  $(document).on('change', 'select.prod', function () {
    const data = $('#license_form').serialize();
    const url = $('input[name="license[url]"]').val();

    $.ajax({
      type: 'GET',
      url: url,
      data: data,
      dataType: 'json',
      success: function (response) {
        $('#license_form').html(response.new_html);
      }
    });
  });
}

window.updateActivitySelect = function () {
  $("[data-update='select']").change(function (el) {
    param = this.value;
    target = $("#activity");
    url = "/customers/get_customer_enum?enum_value=" + param;
    $.getJSON(url, function (json) {
      target.empty();
      target.append($('<option>').text("Seleziona..."));
      $.each(json, function (i, obj) {
        target.append($('<option>').text(obj.text).attr('value', obj.value));
      });
    });
  });
}

window.updateSelect = function () {
  $("[data-update='select']").change(function (el) {
    param = this.value;
    value = this.id;
    customer_service = $("#customer_service");
    activity_groups = $("#activity_group");
    activities = $("#activity");
    url = "/customers/get_customer_enum?" + value + "=" + param;
    $.getJSON(url, function (json) {
      if (value == "customer_id") {
        customer_service.empty();
        activity_groups.empty();
        customer_service.append($('<option>').text("Seleziona..."));
        activity_groups.append($('<option>').text("Seleziona..."));
        $.each(json['customer_services'], function (i, obj) {
          customer_service.append($('<option>').text(obj.text).attr('value', obj.value));
        });
        $.each(json['activity_groups'], function (i, obj) {
          activity_groups.append($('<option>').text(obj.text).attr('value', obj.value));
        });
        if (json['activity_groups'].length == 1) {
          activity_groups.val(json['activity_groups'][0].value)
        }
      }
      if (value == "activity_group" || value == 'customer_id') {
        activities.empty();
        activities.append($('<option>').text("Seleziona..."));

        var activityGroups = {};
        $.each(json['activities'], function (i, obj) {
          if (!activityGroups[obj.group]) {
            activityGroups[obj.group] = $('<optgroup>').attr('label', obj.group);
          }
          activityGroups[obj.group].append(
            $('<option>').text(obj.text).attr('value', obj.value)
          );
        });

        $.each(activityGroups, function (groupLabel, activityGroup) {
          activities.append(activityGroup);
        });

        if (json['activities'].length == 1) {
          activities.val(json['activities'][0].value)
        }
      }
    });
  });
}

window.updateAgentsSelect = function () {
  $("[data-update='partner_select']").change(function (el) {
    param = this.value;
    datatarget = $(this).data('kind');
    target = $("#" + datatarget);
    url = "/partners/get_agents_enum?enum_value=" + param;
    $.getJSON(url, function (json) {
      target.empty();
      target.append($('<option>').text("Seleziona..."));
      $.each(json, function (i, obj) {
        target.append($('<option>').text(obj.text).attr('value', obj.value));
      });
    });
  });
}
